
import './App.css';
import ScheduleComp from './ScheduleComp';


function App() {
  return (
    <div className="App">
      <ScheduleComp />
    </div>
  );
}

export default App;
